export const checkIfOlderThanNDays = (productStartTimestamp?: string, days = 7) => {
	if (!productStartTimestamp) {
		return false;
	}

	const daysInMs = days * 24 * 60 * 60 * 1000;
	const currentDate = new Date();
	const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
	return productAge > daysInMs;
};
